import { ref } from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'

export default function GeofenceReportLogic() {

  const filter_request = ref({
      
    
    areas_owners: [],
    areas_contracts:[],
   
    areas_categories:[],
    

  })

  const errors = ref({})
  const loading = ref(false)
   const geofences=ref([])

   ReportService.getAreasOptions({
    type:'geofence',
    categories:['LANDFILL_AREA'],
    user: store.state.auth.userData.id
   }).then(response => {
     
    geofences.value = response.data.map((d)=>({id:d.geofence_id,"name":d.name}))
    })
   .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
   .finally(() =>  loading.value = false)


  const reFilter = () => {
   
        errors.value = {}    
   
    ReportService.getAreasOptions(
       Object.assign( filter_request.value,{
        type:'geofence',
        user: store.state.auth.userData.id
    
    })
      ).then(response => {
        
        geofences.value = response.data.map((d)=>({id:d.id,"name":d.name}))
        
          emit('divicesFilterd', geofences.value);
       })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() =>  loading.value = false)
  }



  

  return {
    reFilter,
    geofences,    
    filter_request,
    errors,
    loading
   
    
      
  }
}
